var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoodActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_888_11751",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_888_11751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.5008V4.00078L6.5 1.02578C6.625 0.900781 6.77292 0.827865 6.94375 0.807031C7.11458 0.786198 7.27917 0.817448 7.4375 0.900781C7.59583 0.984115 7.7125 1.10078 7.7875 1.25078C7.8625 1.40078 7.87917 1.55495 7.8375 1.71328L7.275 4.00078H10.5C10.7667 4.00078 11 4.10078 11.2 4.30078C11.4 4.50078 11.5 4.73411 11.5 5.00078V6.00078C11.5 6.05911 11.4917 6.12161 11.475 6.18828C11.4583 6.25495 11.4417 6.31745 11.425 6.37578L9.925 9.90078C9.85 10.0674 9.725 10.2091 9.55 10.3258C9.375 10.4424 9.19167 10.5008 9 10.5008H3.5ZM4.5 4.42578V9.50078H9L10.5 6.00078V5.00078H6L6.675 2.25078L4.5 4.42578ZM2 10.5008C1.725 10.5008 1.48958 10.4029 1.29375 10.207C1.09792 10.0112 1 9.77578 1 9.50078V5.00078C1 4.72578 1.09792 4.49036 1.29375 4.29453C1.48958 4.0987 1.725 4.00078 2 4.00078H3.5V5.00078H2V9.50078H3.5V10.5008H2Z",
    fill: "#40DF9F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoodActive);
export default __webpack_public_path__ + "static/media/icon-good-active.f122f7e959550843bbb9460688b63e95.svg";
export { ForwardRef as ReactComponent };